import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';


@Component({
  selector: 'my-convert-equipment-requests',
  templateUrl: './ConvertEquipmentRequests.component.html'
})
export class ConvertEquipmentRequestsComponent implements OnInit {

    userInfo: ent.UserInfo;
    
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    
    constructor(private authenticationService: serv.AuthenticationService, private equipmentService: serv.EquipmentService) 
    { 
      

    }

    ngOnInit(): void {

        this.userInfo = this.authenticationService.getUserInfo();
        
    }

    onConvertClick(event: any){

        this.blockComponent.blocked = true;
        this.equipmentService.convertEquipmentRequests().subscribe(x=> {
            this.blockComponent.blocked = false;
            this.messageHandlerComponent.handleResponse(x);
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });
    }
}
    